import {useMemo, useEffect, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

export const usePersistedSearch = (key: string): string => {
    const location = useLocation();
    const navigate = useNavigate();

    const savedSearch = useMemo(() => {
        if (!location.search) {
            try { return sessionStorage.getItem(key) || ''; } catch {}
        }
        return '';
    }, []);

    const restoredRef = useRef(location.search !== '' || !savedSearch);

    if (!restoredRef.current && location.search) {
        restoredRef.current = true;
    }

    useEffect(() => {
        if (!restoredRef.current && savedSearch) {
            navigate({search: savedSearch}, {replace: true});
        }
        restoredRef.current = true;
    }, []);

    useEffect(() => {
        try {
            sessionStorage.setItem(key, location.search);
        } catch {}
    }, [key, location.search]);

    return restoredRef.current ? location.search : savedSearch;
};
